export const FEATURE_FLAGS = {
  ALMA_POPUP: 'aura-portal-alma-integration',
  COMPOSITE: 'enable-composite',
  ENVIRONMENTS_BETA: 'aura-portal-environments-beta',
  ENVIRONMENTS_COSTS: 'aura-portal-env-cost-dashboard',
  ENVIRONMENTS_METRICS: 'aura-portal-environments-metrics',
  GRAPH_ENGINE: 'enable-graph-engine',
  OPERATIONS: 'aura-operations',
  PERMISSION_ELEVATION: 'aura-portal-permission-elevation',
  PR_LINKS: 'aura-portal-pr-links',
  PRIVATE_ENDPOINT_SERVICE: 'aura-portal-private-endpoint-service-page',
  ROLLOUTS: 'aura-portal-rollouts',
  SIDEBAR_BETA: 'aura-portal-sidebar-beta',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
